// extracted by mini-css-extract-plugin
export default {"wiDocumentsListContainer":"styles_wiDocumentsListContainer__UgD5S","wiDocumentsList":"styles_wiDocumentsList__IWSQA"};